import { useState } from 'react';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { IconButton, Popover, Stack, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useTheme } from '@emotion/react';
import GraphDetails from './GraphDetails';

const PriceInfo = ({ graphData, transactionData }) => {
  const theme = useTheme();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(false);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setIsDropdownOpen(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setIsDropdownOpen(false);
  };
  return (
    <Stack
      direction="row"
      className="flex items-center"
    >
      <Typography className="text-[12px] mr-[5px] !text-[#14285A99]">EEX<span className='!text-[#000000]'>€{graphData?.currentPrice || "0"}/t</span> </Typography>
      <Typography
        className="text-[12px] mr-[5px]"
        style={{ color: graphData?.priceFlag === "increase" ? '#00A632' : graphData?.priceFlag ==='constant' ? '#000000' : "#CB0000", marginLeft: '10px' }}
      >
        {graphData?.priceFlag === "increase" ? "+" : graphData?.priceFlag === 'decrease' ? "-" : graphData?.priceFlag === 'constant' ? '' : null}{graphData?.priceDiference}
      </Typography>
      <Stack>
        {graphData?.priceDiference && graphData?.priceFlag === "increase" ?
          <NorthIcon style={{ color: '#00A632', fontSize: '14px' }} /> :
          graphData?.priceFlag === "decrease" ? 
          <SouthIcon style={{ color: '#CB0000', fontSize: '14px' }} />  : null}
      </Stack>
      <IconButton
        className=" mr-[5px]"
        id="resource-button"
        onClick={handleMenuOpen}
        aria-describedby={id}
        aria-controls={open ? 'resource-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        style={{ marginRight: '10px' }}
      >
        {isDropdownOpen ? <ArrowDropUpIcon style={{ color: theme.palette.grey.main, fontSize: '18px' }} /> : <ArrowDropDownIcon style={{ color: theme.palette.grey.main, fontSize: '18px' }} />}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        style={{ minWidth: "300px", minHeight: "630px" }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <GraphDetails graphData={graphData} transactionData={transactionData}/>
      </Popover>
    </Stack>
  );
};

export default PriceInfo;
